import { useState } from 'react';

import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { styled } from 'styled-components';

const CustomAStyle = styled.a`
  &.card-item {
    position: relative;
    transition: all 0.3s ease-in-out;
    color: #fff;
    background-image: url(${(props) => props['data-bgurl']});
    background-position: center right;
    background-size: cover;
    background-repeat: no-repeat;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(224deg, rgba(247, 252, 255, 0.6) 0%, rgba(28, 47, 65, 0.93) 100%);
      border-radius: 8px;
    }
    h3,
    p {
      position: relative;
      z-index: 2;
    }
  }
  &.active {
    width: 361px;
    height: 239px;
    h3,
    p {
      visibility: hidden;
    }
    &::after {
      display: none;
    }
  }
  @media (min-width: 1552px) {
    &.active {
      width: 467px;
      height: 310px;
    }
  }
`;

const IndexLoinAd = ({ data }) => {
  const [activeIdx, setActiveIdx] = useState(0);

  function handleHoverAd(idx) {
    setActiveIdx(idx);
  }
  function loinAdBuriedPoint() {
    buriedPoint({
      cp: 'index',
      ty: 'click',
      op: 'Central_AD',
      data: {
        hf: data?.loinCarouselBanners[activeIdx]?.targetLink || '',
        ix: activeIdx,
      },
    });
  }
  if (data) {
    const { loinCarouselBanners } = data;
    if (loinCarouselBanners) {
      return (
        <section
          className="mx-auto mt-[20px] w-[1200px] h-[239px] _lg:w-[1552px] _lg:h-[310px] rounded-[20px] flex justify-between"
          data-spm="ylb"
        >
          {loinCarouselBanners.slice(0, 8).map((loinAd, idx) => (
            <CustomAStyle
              key={idx}
              href={loinAd?.targetLink}
              target="_blank"
              title={loinAd.title}
              className={`card-item inline-block w-[112px] px-[10px] h-[239px] _lg:w-[145px] _lg:h-[310px] rounded-[8px] ${idx === activeIdx ? 'active' : ''}`}
              data-bgurl={loinAd.advertisingUrl}
              onMouseEnter={() => handleHoverAd(idx)}
              onClick={loinAdBuriedPoint}
              data-spm={idx + 1}
            >
              <div className="w-full mt-[128px] _lg:mt-[216px] text-white">
                <p className="text-[18px] font-bold leading-[24px]">{loinAd.title}</p>
                <p className="text-[14px] leading-[19px] mt-[10px]">{loinAd.viceTitle}</p>
              </div>
            </CustomAStyle>
          ))}
        </section>
      );
    }
  }
};

export default IndexLoinAd;
